import React, { Component } from "react";
import { BlockPicker } from "react-color";

class ColorPicker extends Component {
  constructor(props) {
    super(props);
    this.handleColorChange = this.handleColorChange.bind(this);
  }

  handleColorChange(color, event) {
    this.props.updateUrl(this.props.name, color.hex.substr(1));
  }

  render() {
    return (
      <div
        className={
          this.props.color === "ffffff" ? "Picker-black Picker" : "Picker"
        }
      >
        <h4>{this.props.title}</h4>
        <BlockPicker
          colors={this.props.colors.map(c => "#" + c)}
          color={this.props.color}
          onChangeComplete={this.handleColorChange}
          width="180px"
        />
      </div>
    );
  }
}
export default ColorPicker;



// WEBPACK FOOTER //
// ./src/ColorPicker.js